export interface IVrlTransactionGroup {
     All: boolean,
     Completed: boolean
}